var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9054 0.134552H3.08726C1.83638 0.134552 0.818176 1.15271 0.818176 2.41092V5.13091H37.1818V2.41092C37.1818 1.15271 36.1637 0.134552 34.9054 0.134552Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1818 6.58545H0.818176V10.7745H37.1818V6.58545Z",
    fill: "#A4A4A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.818176 23.5891C0.818176 24.8473 1.83638 25.8655 3.08726 25.8655H34.9054C36.1637 25.8655 37.1818 24.8473 37.1818 23.5891V12.2291H0.818176V23.5891ZM28.12 15.9309C28.6436 15.5163 29.2836 15.2982 29.9746 15.2982C31.64 15.2982 33 16.6509 33 18.3236C33 19.9891 31.64 21.3418 29.9746 21.3418C29.2836 21.3418 28.6436 21.1236 28.12 20.7018C27.3928 20.1418 26.9564 19.2545 26.9564 18.3236C26.9564 17.3854 27.3782 16.5127 28.12 15.9309ZM26.6291 15.3491C25.9091 16.1636 25.5018 17.2109 25.5018 18.3236C25.5018 19.4291 25.9236 20.4909 26.6291 21.2909C25.2254 21.0364 24.1491 19.8073 24.1491 18.3236C24.1491 16.8327 25.2254 15.6036 26.6291 15.3491ZM5.90909 15.8218H13C13.4 15.8218 13.7273 16.1491 13.7273 16.5491C13.7273 16.9564 13.4 17.2764 13 17.2764H5.90909C5.50909 17.2764 5.18181 16.9564 5.18181 16.5491C5.18181 16.1491 5.50909 15.8218 5.90909 15.8218ZM5.90909 19.3564H13C13.4 19.3564 13.7273 19.6836 13.7273 20.0836C13.7273 20.4836 13.4 20.8109 13 20.8109H5.90909C5.50909 20.8109 5.18181 20.4836 5.18181 20.0836C5.18181 19.6836 5.50909 19.3564 5.90909 19.3564Z",
    fill: "#A4A4A4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.41f5c92e171ee2652902e1a0b9a6ff2b.svg";
export { ForwardRef as ReactComponent };